export default __webpack_public_path__ + "static/media/loader.55b8e4d5.gif";